import { render } from "./RequirementsTable.vue?vue&type=template&id=041884dc&scoped=true"
import script from "./RequirementsTable.vue?vue&type=script&lang=js"
export * from "./RequirementsTable.vue?vue&type=script&lang=js"

import "./RequirementsTable.vue?vue&type=style&index=0&id=041884dc&scoped=true&lang=css"
import "./RequirementsTable.vue?vue&type=style&index=1&id=041884dc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041884dc"]])

export default __exports__